import { style } from "@vanilla-extract/css";
import { theme } from "../../theme/css/theme.css";

export const subPaneStyle = style({
  padding: theme.spacings.m,
  gap: theme.spacings.m,
  borderRadius: theme.borderRadiuses.s,
  backgroundColor: theme.colors.panel,
});

export const subPaneInnerStyle = style({
  gap: theme.spacings.xs,
});
